import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createModalidadSchema = yup.object({
  nombre: yup.string().required(DEFAULT_MESSAGES.REQUIRED),
});
